import React, { useMemo, useRef, useState, useContext, useCallback } from 'react'
import {ElementContext} from '../ElementContext';
import { AgGridReact } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '../../styles/table.css'
import { WAPICategoryRenderer, WAPILanguageRenderer, WAPINameRenderer, WAPIStateRenderer } from '../whatsappAPICloud/WhatsappAPIRenderer';
import WAPIEditTemplateModal from '../modals/WAPIEditTemplateModal';


const WhatsappTemplatesTable = () => {
    
    const { whatsappTemplates, setWAPIEditTemplateModalOpen, setTemplateData } = useContext(ElementContext)
    const { t } = useTranslation()
  
    const gridRef = useRef(); // Optional - for accessing Grid's API
    const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row

    // Each Column Definition results in one Column.
    const [columnDefs, setColumnDefs] = useState([
        {
            field: 'name',
            headerName: t('templateName'),
            cellRenderer: WAPINameRenderer
        },
        {
            field: 'category',
            headerName: t('category'),
            cellRenderer: WAPICategoryRenderer
        },
        {
            field: 'language',
            headerName: t('language'),
            cellRenderer: WAPILanguageRenderer
        },
        {
            field: 'status',
            headerName: t('status'),
            cellRenderer: WAPIStateRenderer
            // wrapText: true,
            // autoHeight: true,
        }
    ]);
    
    // DefaultColDef sets props common to all Columns
    const defaultColDef = useMemo( ()=> ({ sortable: true, filter: true }) );

    
    const onFirstDataRendered = useCallback( async() => {
        gridRef.current.api.sizeColumnsToFit();
        // const allColumnIds = [];
        // await gridRef.current.columnApi.getColumns().forEach((column) => {
        //     allColumnIds.push(column.getId());
        // });
        // await gridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
    }, []);

    const handleCellClicked = (e) => {
        try {
            console.log('🖱️ Celda clickeada, datos:', e.data);
            
            // 1️⃣ Validar que existan datos
            if (!e.data) {
                console.error('❌ No hay datos en la celda');
                return;
            }

            // 2️⃣ Validar que tenga componentes
            if (!e.data.components || !Array.isArray(e.data.components)) {
                console.error('❌ Template sin componentes válidos:', e.data);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Esta plantilla no tiene un formato válido'
                });
                return;
            }

            // 3️⃣ Validar que tenga al menos un componente BODY
            const hasBody = e.data.components.some(comp => comp.type === 'BODY');
            if (!hasBody) {
                console.error('❌ Template sin componente BODY:', e.data);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Esta plantilla no tiene un cuerpo de mensaje'
                });
                return;
            }

            // 4️⃣ Si todo está bien, guardar en contexto y abrir modal
            console.log('✅ Template válido, abriendo modal');
            setTemplateData(e.data);
            setWAPIEditTemplateModalOpen(true);

        } catch (error) {
            console.error('❌ Error al procesar template:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al abrir la plantilla: ' + error.message
            });
        }
    }


    return (
        <div className='h-100'>
            <div className="ag-theme-alpine h-100" style={{width: "100%"}}>
                <AgGridReact
                    ref={gridRef}
                    rowData={whatsappTemplates}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={true}
                    pagination={true}
                    onCellClicked={ handleCellClicked }
                    onFirstDataRendered={onFirstDataRendered}
                    paginationPageSize={15}
                    paginationPageSizeSelector={[15, 20, 50, 100]}
                />
            </div>

            <WAPIEditTemplateModal />
        </div>
    )
}

export default WhatsappTemplatesTable